(function () {
  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-le-copy-link]');
    if (copyBtn) {
      e.preventDefault();
      var url = copyBtn.getAttribute('data-url') || window.location.href;
      var done = function () {
        var prev = copyBtn.textContent;
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = prev; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(function () {
          window.prompt('Copy this link:', url);
        });
      } else {
        window.prompt('Copy this link:', url);
      }
      return;
    }
    var printBtn = e.target.closest('[data-le-print]');
    if (printBtn) {
      e.preventDefault();
      window.print();
    }
  });
})();
